import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Card, Button, Divider, Modal } from 'antd';
import { getAdminUsers, addAdminUser, deleteAdminUser, editAdminUser } from '../../actions';
import { MODAL_ADD, MODAL_EDIT } from '../../appConstants';
import StandardTable from '../../components/StandardTable';
import PageHeaderLayout from '../../layouts/PageHeaderLayout';
import UserInputForm from '../../components/UserInputForm';

import './Admin.less';

class Admins extends PureComponent {
  static propTypes = {
    users: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    })).isRequired,
    userId: PropTypes.string.isRequired,
    isFetching: PropTypes.bool.isRequired,
    getAdminUsers: PropTypes.func.isRequired,
    addAdminUser: PropTypes.func.isRequired,
    editAdminUser: PropTypes.func.isRequired,
    deleteAdminUser: PropTypes.func.isRequired,
  };

  state = {
    modalVisible: false,
    modalType: '',
    editingUser: {},
  };

  componentDidMount() {
    this.props.getAdminUsers();
  }

  onEdit = (user) => {
    const adminId = this.state.editingUser.id;
    if (adminId && user) this.props.editAdminUser(adminId, user);
  };

  handleModalVisible = (modalType, flag) => {
    this.setState({ modalType, modalVisible: flag });
  };

  handleEditClick = (user) => {
    this.handleModalVisible(MODAL_EDIT, true);
    this.setState({ editingUser: user });
  };

  handleDeleteClick = (user) => {
    Modal.confirm({
      title: 'Do you want to delete this admin user?',
      content: user.email,
      okText: 'Yes',
      okType: 'danger',
      onOk: () => {
        this.props.deleteAdminUser(user.id);
      },
    });
  };

  render() {
    const { modalType, modalVisible, editingUser } = this.state;
    const {
      match: { path }, users, isFetching, addAdminUser, userId,
    } = this.props;
    // config for admin users table
    const columns = [{
      title: 'Email',
      dataIndex: 'email',
    }, {
      title: 'Actions',
      dataIndex: 'actions',
      render: (text, record) => (
        <Fragment>
          <a className="btn-edit" onClick={() => { this.handleEditClick(record); }}>edit</a>
          {record.id !== userId && (
          <Fragment>
            <Divider type="vertical" />
            <a className="btn-delete" onClick={() => { this.handleDeleteClick(record); }}>delete</a>
          </Fragment>
            )}
        </Fragment>
      ),
    }];
    const data = users ? users.map(user => ({ key: user.id, ...user })) : [];

    return (
      <PageHeaderLayout title="Admins" description="Manage admin users" className="admins" path={path}>
        <Card bordered={false}>
          <div className="operator">
            <Button className="btn-add" icon="plus" type="primary" onClick={() => { this.handleModalVisible(MODAL_ADD, true); }} >Add</Button>
          </div>
          <StandardTable columns={columns} data={data} loading={isFetching} />
        </Card>
        <UserInputForm
          modalType={modalType}
          modalVisible={modalVisible}
          handleModalVisible={this.handleModalVisible}
          editingUser={editingUser || null}
          handleSubmit={modalType === MODAL_ADD ? addAdminUser : this.onEdit}
        />
      </PageHeaderLayout>
    );
  }
}

function mapStateToProps({ auth, admin }) {
  return {
    userId: auth.user.uid,
    users: admin.users,
    isFetching: admin.isFetching,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getAdminUsers, addAdminUser, deleteAdminUser, editAdminUser,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Admins);



// WEBPACK FOOTER //
// ./src/routes/Admin/Admins.js